import { ActionModeType, IsiDtoPlRacRequest, IsiDtoPlRacResponse, IsiDtoPlRacResult } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlRac";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export class IsiPlRac extends IsiPresentationLogic {

    constructor() {
        super("IsiPlRacHandler");
    }

    /**
     * Traitement pour récupérer le menu
     * */
    public async GetAndBuildCsRac(requestedRacValue: string, extendedNews: boolean): Promise<IsiDtoPlRacResult> {
        const params = IsiDtoPlRacRequest.fromJS({
            requestedRacValue: requestedRacValue,
            extendedNews: extendedNews,
            response: IsiDtoPlRacResponse.fromJS({})
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlRacRequest> = await this.ajaxWithErrorHandling("GetAndBuildCsRac", params, true);
        const dto = result?.reponse?.response?.result;

        switch (dto.actionMode) {
            case ActionModeType.DirectOpen: {
                window.open(dto.actionValue);
                break;
            }
            case ActionModeType.ExecuteRaccourci: {
                executeRaccourci(' ', dto.actionValue);
                break;
            }
            case ActionModeType.LaunchRacBandeau: {
                iws_launchRacBandeau(dto.actionValue);
                break;
            }
            default: {
                // rien ici
                break;
            }
        }
        return dto;

    }

}
